import { useContext } from 'react';
import { RootContext, actionTypes } from 'RootContext/rootContext';

export const useSnackbar = (isDrawer = false) => {
  const { actions, rootDispatch } = useContext(RootContext);

  return ({
    autoHideDuration = 4000,
    message,
    severity,
    onAction = null,
    actionLabel = null,
    actionType = null,
  }) => {
    actions.onAction = onAction;
    actions.label = actionLabel;
    actions.type = actionType;

    rootDispatch({
      snackbar: { autoHideDuration, message, severity },
      type: isDrawer
        ? actionTypes.SHOW_DRAWER_SNACKBAR
        : actionTypes.SHOW_GLOBAL_SNACKBAR,
    });
  };
};
